import React, { useState } from 'react';
import {
  Box,
  Typography,
  CircularProgress,
  Popover,
  Grid
} from '@mui/material';

function MatchScore({ score, breakdown, size = 'medium' }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const sizeMap = {
    small: { size: 40, fontSize: '0.75rem' },
    medium: { size: 60, fontSize: '1rem' },
    large: { size: 80, fontSize: '1.25rem' }
  };

  const { size: circleSize, fontSize } = sizeMap[size] || sizeMap.medium;

  const getColor = (score) => {
    if (score >= 80) return '#4caf50'; // Green
    if (score >= 60) return '#ff9800'; // Orange
    return '#f44336'; // Red
  };

  const content = (
    <Box
      sx={{
        position: 'relative',
        width: circleSize,
        height: circleSize,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: breakdown ? 'pointer' : 'default'
      }}
      onClick={(e) => breakdown && setAnchorEl(anchorEl ? null : e.currentTarget)}
    >
      <CircularProgress
        variant="determinate"
        value={score}
        size={circleSize}
        thickness={4}
        sx={{
          color: getColor(score),
          position: 'absolute'
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontSize,
            fontWeight: 'bold',
            color: getColor(score)
          }}
        >
          {score}%
        </Typography>
        {size !== 'small' && (
          <Typography
            variant="caption"
            sx={{
              fontSize: fontSize * 0.7,
              color: 'text.secondary',
              lineHeight: 1
            }}
          >
            Match
          </Typography>
        )}
      </Box>
    </Box>
  );

  const open = Boolean(anchorEl);

  if (!breakdown) {
    return content;
  }

  return (
    <>
      <Box onClick={(e) => setAnchorEl(anchorEl ? null : e.currentTarget)}>
        {content}
      </Box>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          sx: {
            p: 2,
            minWidth: 280,
            maxWidth: 320,
            boxShadow: 4,
            borderRadius: 2
          }
        }}
      >
        <Typography variant="subtitle2" fontWeight={600} gutterBottom>
          Ido Compatibility Score Breakdown
        </Typography>
        <Box sx={{ mt: 1.5 }}>
          <Grid container spacing={1.5}>
            {Object.entries(breakdown).map(([factor, data]) => (
              <Grid item xs={12} key={factor}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography variant="body2" sx={{ textTransform: 'capitalize', color: 'text.secondary' }}>
                    {factor.replace(/([A-Z])/g, ' $1').trim()}
                  </Typography>
                  <Typography variant="body2" fontWeight={600} sx={{ color: getColor(data.score) }}>
                    {data.score}%
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Popover>
    </>
  );
}

export default MatchScore;
